import type { GenieKnowledgeBlock } from '../types';

/** Micro-copy para desempates Genie (ELA vs NMM, MG vs LEMS) */
export const TIEBREAKER_SNIPPETS: Record<string, GenieKnowledgeBlock[]> = {
  ela_vs_mmn: [
    {
      type: 'headline',
      content:
        'ELA y NMM comparten denervación motora, pero la NMM es tratable con inmunoterapia.',
    },
    {
      type: 'bullets',
      content: [
        'NMM: bloqueo de conducción motor en segmento atípico + SNAP sensitivo normal',
        'ELA: denervación difusa sin bloqueos; SNAPs sensitivos normales',
        'Anti-GM1 y ecografía de nervio orientan hacia NMM',
      ],
    },
  ],
  mg_vs_lems: [
    {
      type: 'headline',
      content:
        'MG y LEMS son trastornos de la unión neuromuscular con patrones RNS opuestos.',
    },
    {
      type: 'bullets',
      content: [
        'MG: decremento >10% en RNS a 2–3 Hz (trapecio/facial)',
        'LEMS: incremento >60% del CMAP tras ejercicio breve o estimulación rápida',
        'LEMS: PUMs de baja amplitud; asociación frecuente con neoplasia (pulmón)',
      ],
    },
  ],
};
